import Matter from "./views/Matter";

const routes = [
  {
    path: "/matters/:uid",
    name: "matter",
    component: Matter,
    props: route => ({
      uid: route.params.uid,
      mobileView: route.query.MobileView === '1',
      paneView: route.query.PaneView === '1' || route.query.paneView === 'true',
      tab: route.query.tab,
      openOrigin: route.query.openOrigin
    })
  }
];

export default routes;
